export const prettyAmount = (value, fixed = 2) => {
  if ([null, undefined].includes(value)) {
    return value;
  }
  let [fst, snd] = parseFloat(value).toFixed(fixed).split('.');
  fst = fst.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return [fst, snd].filter(Boolean).join('.');
}